import React, { useEffect, useState } from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import Create from "@components/Compliance/Create.jsx";
import EditModal from "@components/Modals/Admin/ComplianceEditModal/Index.jsx";
import { useGenericReducer } from '@hooks/state/useGenericReducer.js'
import GridCompliance from '@components/Compliance/Grid.jsx';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';

function Compliance() {
  const NomeForm = "Cadastro de Compliance";
  const [selectedRow, setSelectedRow] = useState(null);
  const [clearFields, setClearFields] = useState(false);
  const { state, setData, addItem, updateItem, deleteItem } = useGenericReducer();

  const [visible, setVisible] = useState(false);
  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  const handleDelete = (id) => {
    const itemToDelete = state.data.find((item) => item.id === id);

    if (itemToDelete && itemToDelete.tipoCompliance) {
      deleteItem(id);
      setClearFields(true);
    }
  }

  useEffect(() => {
    if (clearFields) {
      setClearFields(false);
    }
  }, [clearFields]);

  return (
    <PageWrapper>
      <BreadcrumbComp Param1="Home" Param2="Solicitações e Pendências" Param3={NomeForm} />
      <div className="row">
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6 d-flex align-items-center">
                  <h2 className="mb-0">{NomeForm}</h2>
                </div>
                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <Create
                  onSave={addItem}
                  clearFields={clearFields}
                />

                <EditModal
                  visible={visible}
                  closeModal={closeModal}
                  selectedRow={selectedRow}
                  onUpdate={updateItem}
                />

                <GridCompliance
                  state={state}
                  setData={setData}
                  openModal={openModal}
                  setSelectedRow={setSelectedRow}
                  onDelete={handleDelete}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  )
}

export default Compliance;